import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { profile } from '@/content/profile'

interface LocalTimeProps {
    className?: string
}

export const LocalTime: FC<LocalTimeProps> = ({ className }): ReactNode => {
    const [time, setTime] = useState('--:--')

    useEffect(() => {
        const formatter = new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: profile.timeZone
        })

        const update = () => setTime(formatter.format(new Date()))

        update()

        const interval = window.setInterval(update, 20000)

        return () => window.clearInterval(interval)
    }, [])

    return (
        <time className={className} suppressHydrationWarning>
            {time}
        </time>
    )
}
